module.exports = __webpack_public_path__ + "static/media/card-ads-br.df57a244.png";